import { COLORS, TYPOGRAPHY } from '@app/constants';
import { ModifiedGroup } from '../../types';
import { FC } from 'react';
import styled, { css } from 'styled-components';

interface Props {
  groups?: ModifiedGroup[];
  currentGroup?: ModifiedGroup;
  onChooseGroup: (group: ModifiedGroup) => void;
}

const GroupList: FC<Props> = ({ groups, currentGroup, onChooseGroup }) => {
  return (
    <Root>
      {groups?.map((item, index) => {
        return (
          <ListItem
            key={index}
            onClick={() =>
              currentGroup?.label !== item.label && onChooseGroup(item)
            }
          >
            <ListButton
              type="button"
              $isCurrent={currentGroup?.label === item.label}
            >
              {item.label}
            </ListButton>
          </ListItem>
        );
      })}
    </Root>
  );
};

export default GroupList;

interface StyleProps {
  $isCurrent: boolean;
}

const Root = styled.ul`
  padding-left: 16px;
  padding-right: 16px;
  display: flex;
  width: 100%;
  overflow-x: auto;
  background-color: ${COLORS.white};
`;

const ListItem = styled.li`
  &:not(:first-child) {
    margin-left: 24px;
  }
`;

const ListButton = styled.button<StyleProps>`
  padding-bottom: 8px;

  ${({ $isCurrent }) => {
    if ($isCurrent) {
      return css`
        position: relative;
        ${TYPOGRAPHY.body1Medium14}
        color: ${COLORS.grayscale700};

        &:after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 1px;
          background-color: ${COLORS.primary400};
        }
      `;
    } else {
      return css`
        ${TYPOGRAPHY.body1Regular14}
        color: ${COLORS.grayscale500};
      `;
    }
  }};
`;
